var React = require('react');

function Impressions (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.624 7.028C28.37 6.74 22.282 0 14.5 0 6.718 0 .631 6.74.376 7.028a1.446 1.446 0 0 0 0 1.945C.63 9.26 6.718 16 14.5 16c7.782 0 13.87-6.74 14.124-7.028a1.445 1.445 0 0 0 0-1.944zm-11.747-2.98c.523-.272 1.253.041 1.63.701.376.66.257 1.417-.266 1.69-.523.274-1.253-.04-1.63-.7-.376-.66-.257-1.417.266-1.69zm-2.377 9.51C9.064 13.558 4.49 9.564 2.906 8c1.07-1.056 3.504-3.22 6.645-4.513A5.46 5.46 0 0 0 8.58 6.59c0 3.129 2.651 5.664 5.92 5.664 3.27 0 5.922-2.535 5.922-5.664a5.46 5.46 0 0 0-.972-3.104C22.59 4.78 25.025 6.944 26.094 8c-1.583 1.565-6.158 5.558-11.594 5.558z","fill":"currentColor"}));
}

Impressions.defaultProps = {"viewBox":"0 0 29 16","width":"29","height":"16"};

module.exports = Impressions;

Impressions.default = Impressions;
